<template>
  <div class="u-pad-y-lg u-bg-black u-row u-center">
    <a :href="'mailto:' + address.mail" :title="address.type" class="u-w3of12 u-w8of12--sm u-pad-y-md--sm u-block" v-for="address in addresses">
      <div class="u-row u-center">
        <div class="u-w4of12">
          <div class="u-box-1by1">
            <img class="u-wrapper-panel" :src="`/images/${address.type}--sphere.png`">
          </div>
        </div>
      </div>
      <div class="u-center u-marg-t-sm t-text--small t-light">
        {{ address.mail }}
      </div>
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      addresses: [
        {
          type: 'pompidou',
          mail: 'contact@centrepompidou.fr'
        },
        {
          type: 'bright',
          mail: 'contact@brig.ht'
        },
        {
          type: 'game-in-society',
          mail: 'contact@gameinsociety.com'
        }
      ]
    } 
  }
}
</script>